import { useState } from "react";

import { ActionIcon, Group } from "@mantine/core";
import {
	IconMenu,
	IconMenu2,
	IconMenu3,
	IconSettings,
} from "@tabler/icons-react";

import { CaregiverAppSettingsDrawer } from "./CaregiverAppSettingsDrawer";

export function CaregiverAppSettingsButton() {
	const [drawerOpened, setDrawerOpened] = useState(false);

	return (
		<Group>
			<ActionIcon
				size="lg"
				variant="default"
				aria-label="Open menu"
				onClick={() => setDrawerOpened(true)}
			>
				<IconMenu2 />
			</ActionIcon>
			<CaregiverAppSettingsDrawer
				opened={drawerOpened}
				onClose={() => setDrawerOpened(false)}
			/>
		</Group>
	);
}
